







import Component from "vue-class-component";
import Vue from "vue";
import OrderItem from "./module/orderItem.vue";
import moduleStore from "./store/index";
@Component({
  components: { },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  imgUrl=null
  pdfUrl=null
  mounted() {
    this.imgUrl = this.$route.query.imgUrl
    this.pdfUrl = this.$route.query.pdfUrl
  }
}
